
import {axios} from '../index'
import version from '@/dd_version';
let scope = 'useSaleActivity'

export default {
  // 根据日期计算月租金
  rentPrice: {
    getPayPriceOfMonth(params) {
     return axios.post(`/${scope}/getPayPrice`, params)
    },
    getPayPriceOfMonthFromBusiness(params) {
      return axios.post(`${scope}/getPayPriceForSome`, params)
    },
    getUnitWeight(params) {
      return axios.post(`${scope}/getUnitWeight`, params, {
        headers: {
          'version-key': version
        }
      })
    }
  }

}



// WEBPACK FOOTER //
// ./src/xhr/services/saleRule.js